<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 210px'>
        <p>供应商：</p>
        <el-input v-model='supplierIpt' size='mini' style='width:150px' placeholder='请输入供应商' />
      </div>
      <div class='navContainer' style='width: 210px'>
        <p>车牌号：</p>
        <el-input v-model='carIpt' size='mini' style='width:150px' placeholder='请输入车牌号' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>司机姓名：</p>
        <el-input v-model='driverIpt' size='mini' style='width:150px' placeholder='请输入司机姓名' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>状态：</p>
        <el-select v-model='stateIpt' filterable size='mini' style='width:150px'>
          <el-option v-for='item in stateOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navContainer' style='width: 420px'>
        <p style='width: 80px;'>计划日期：</p>
        <el-date-picker
          v-model='planDate'
          type='daterange'
          size='mini'
          range-separator='至'
          start-placeholder='开始日期'
          end-placeholder='结束日期'
          value-format='yyyy-MM-dd' />
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span='24' class='exportButton' style='text-align: end;font-size: 14px!important;'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column prop='supplierName' label='供应商' min-width='150' align='center' />
          <el-table-column prop='consignorName' label='委托商' min-width='150' align='center' />
          <el-table-column prop='truckName' label='车牌号' align='center' />
          <el-table-column prop='driverName' label='司机姓名' align='center' />
          <el-table-column prop='driverTel' label='联系电话' min-width='120' align='center' />
          <el-table-column prop='fleetCount' label='委托车数量' align='center' />
          <el-table-column prop='startName' label='出发地' min-width='150' align='center' />
          <el-table-column prop='deliveryName' label='目的地' min-width='150' align='center' />
          <el-table-column prop='planDate' label='计划时间' min-width='150' align='center' />
          <el-table-column prop='entruckDate' label='装车时间' min-width='150' align='center' />
          <el-table-column label='状态' align='center'>
            <div slot-scope='scope'>{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label='操作' width='180' align='center'>
            <template slot-scope='scope'>
              <div style='align-items:center;'>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.row.id)'>详情
                </el-button>
                <el-button v-if='scope.row.status==1||scope.row.status==2' size='mini'
                           class='yellow-bg' type='primary'
                           @click="addressClick('线路跟踪',scope.row.id)">地图跟踪
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog title='详情' :visible.sync='detailDialogVisible' width='750px' center top='10vh'
               @close='dialogClose'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>供应商：</span>
              <span>{{ detailData.supplierName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>车牌号：</span>
              <span>{{ detailData.truckName }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>司机姓名：</span>
                <span>{{ detailData.driverName }}</span>
              </div>
              <div>
                <span class='span1'>司机手机号：</span>
                <span>{{ detailData.driverTel }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>运输数量：</span>
              <span>{{ detailData.fleetCount }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>装车时间：</span>
                <span>{{ getTime(detailData.entruckDate) }}</span>
              </div>
              <div>
                <span class='span1'>运输时间：</span>
                <span>{{ getTime(detailData.transportDate) }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>交车时间：</span>
              <span>{{ getTime(detailData.deliveryDate) }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>起始地：</span>
              <span v-if='detailData.startType!=1'>{{ detailData.startName }}</span>
              <span v-else>{{ detailData.startName }}【{{ detailData.startPortName }}】</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>交车地：</span>
              <span v-if='detailData.deliveryType!=1'>{{ detailData.deliveryName }}</span>
              <span v-else>{{ detailData.deliveryName }}【{{ detailData.deliveryPortName }}】</span>
            </div>
          </div>
        </div>
        <!-- <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>当前位置</span>
          </div>
          <div style="height:150px;padding-right: 20px;margin: 20px 0;position: relative">
            <routeMap :center="center" v-if="!mapDialogVisible"/>
            <i class="el-icon-zoom-in" style="font-size: 35px;position: absolute;top: 0;right: 36px;cursor: pointer" @click=seeMap></i>
          </div>
        </div> -->
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>委托车信息</span>
          </div>
          <div class='operationTable'>
            <el-table :data='detailData.carList' border>
              <el-table-column prop='batchNumber' label='批次号' min-width='150' align='center' />
              <el-table-column prop='billNumber' label='运单号' min-width='150' align='center' />
              <el-table-column prop='frameNumber' label='车架号' min-width='150' align='center' />
              <el-table-column prop='brand' label='品牌' align='center' />
              <el-table-column prop='model' label='型号' align='center' />
              <el-table-column prop='color' label='颜色' align='center' />
              <el-table-column prop='fileName' label='附件' align='center' />
              <el-table-column prop='state' label='状态' align='center'>
                <div slot-scope='scope'>{{ getCarState2(scope.row.state) }}</div>
              </el-table-column>
            </el-table>
            <div class='paginationContainer'>
              <span>共{{ carTotal }}条</span>
              <el-pagination
                background
                :page-sizes='[10, 20, 30, 40]'
                layout='sizes,prev, pager, next,jumper'
                :total='carTotal'
                @size-change='carContractSizeChange'
                @current-change='carContractCurrentChange'
                @prev-click='carContractCurrentChange'
                @next-click='carContractCurrentChange'
              />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title='dialogTitle' :visible.sync='mapDialogVisible' width='850px' center
               :close-on-click-modal='false'>
      <div style='height: 700px;'>
        <!-- 放地图 -->
        <routeMap2 :center='center' :line-arr='lineArr' v-if='mapDialogVisible' ref='routeMap2' />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    vehicleDeployInfoCvFleetList,
    vehicleDeployInfoCvFleetDetail,
    HighwayTrackMesSummaryHighwayLongitude, getCarDeatilsById,
  } from '@/service/vehiclelog';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import routeMap from '@/components/routeMap';
  import { baseUrl } from '@/config/env';

  export default {
    components: {
      routeMap,
      routeMap2: routeMap,
    },
    data() {
      return {
        supplierIpt: '',
        awbIpt: '',
        driverIpt: '',
        carIpt: '',
        timeIpt: '',
        stateIpt: '',
        stateOption: [{
          value: '',
          label: '全部',
        }, {
          value: '1',
          label: '运输中',
        }, {
          value: '2',
          label: '已交车',
        }],
        // stateOption: [{value:'',label:'全部'},{value:'0',label:'待开始'},{value:'1',label:'运输中'},
        // {value:'2',label:'已交车'},{value:'5',label:'装车中'}],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        lineArr: [],//轨迹回放坐标
        center: [],//当前位置
        detailDialogVisible: false,
        detailData: {
          carList: [],
        },
        mapDialogVisible: false,
        dialogTitle: '',
        carParams: {
          id: '',
          page: 1,
          rows: 10,
        },
        carTotal: 0,
        planDate: ['', ''],
      };
    },
    computed: {
      getTime() {
        return function(time) {
          return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
        };
      },
      getState() {
        return function(state) {
          switch (state) {
            // case 0:
            //   return '待开始'
            case 1:
              return '运输中';
            case 2:
              return '已交车';
            // case 5:
            //   return '装车中'
          }
        };
      },
      getCarState2() {
        return function(state) {
          switch (state) {
            case 0:
              return '待运输';
            case 1:
              return '运输中';
            case 2:
              return '已交车';
          }
        };
      },
    },
    mounted() {
      //this._vehicleDeployInfoCvFleetList();
    },
    methods: {
      async _vehicleDeployInfoCvFleetList() {
        this.tableLoad = true;
        const res = await vehicleDeployInfoCvFleetList(
          {
            supplierName: this.supplierIpt,
            taskNumber: this.awbIpt,
            truckName: this.carIpt,
            driverName: this.driverIpt,
            status: this.stateIpt,
            startPlanDate: this.planDate[0] ? this.planDate[0] : '',
            endPlanDate: this.planDate[1] ? this.planDate[1] : '',
            rows: this.size,
            page: this.page,
          },
        );
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      //委托车
      // async _HighwayTrackMesselVehicleDeployCarCvByDriveId(id){
      //   let res = await HighwayTrackMesselVehicleDeployCarCvByDriveId(id)
      //   if (res.status !==0) return this.$message.error(res.message);
      //   this.detailData.carList =res.data
      // },
      async addressClick(title, id) {
        this.dialogTitle = title;
        //当前位置
        let res = await HighwayTrackMesSummaryHighwayLongitude(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.lineArr = res.data;
        this.center = res.data[0];
        // this.center = res.data[res.data.length-2];
        this.mapDialogVisible = true;
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._vehicleDeployInfoCvFleetList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._vehicleDeployInfoCvFleetList();
      },
      carContractSizeChange(sizes) {
        this.carParams.rows = sizes;
        this.getCarList();
      },
      carContractCurrentChange(page) {
        this.carParams.page = page;
        this.getCarList();
      },
      async detailClick(id) {
        //获取位置
        // let res1 = await HighwayTrackMesSummaryHighwayLongitude(id)
        // if (res1.status !==0) return this.$message.error(res1.message);
        // this.lineArr= res1.data
        // this.center = res1.data[0];

        const res = await vehicleDeployInfoCvFleetDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        // this.detailData.carList = res.data.vehicleCarList;
        await this.getCarList(id);
        this.detailDialogVisible = true;
      },
      async getCarList(id) {
        id ? this.carParams.id = id : '';
        const data = await getCarDeatilsById(this.carParams);
        this.detailData.carList = data.data.records;
        this.carTotal = data.data.total;
        this.$forceUpdate();
      },
      seeMap() {
        this.mapDialogVisible = true;
        this.dialogTitle = '查看轨迹';
        this.$nextTick(() => {
          // this.$refs.routeMap2.startAnimation()
        });

      },
      dialogClose() {
        this.center = [];
        this.lineArr = [];
        this.detailData = {};
      },
      searchBtn() {
        const isPlanDateStart = Date.parse(this.planDate[0]);
        if (!isPlanDateStart) return  this.$message.warning('请选择计划时间！');
        this.page = 1;
        this._vehicleDeployInfoCvFleetList();
      },
      resetBtn() {
        this.awbIpt = '';
        this.supplierIpt = '';
        this.stateIpt = '';
        this.carIpt = '';
        this.timeIpt = '';
        this.driverIpt = '';
        this.planDate = ['', ''];
      },
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/HighwayTrackMes/export?access_token=${token}&supplierName=${this.supplierIpt}&truckName=${this.carIpt}&driverName=${this.driverIpt}&states=${this.stateIpt}&status=${this.stateIpt}&startPlanDate=${this.planDate[0] ? this.planDate[0] : ''}&endPlanDate=${this.planDate[1] ? this.planDate[1] : ''}`;
        window.exportExcelGet('/platform/HighwayTrackMes/export', `supplierName=${this.supplierIpt}&truckName=${this.carIpt}&driverName=${this.driverIpt}&states=${this.stateIpt}&status=${this.stateIpt}&startPlanDate=${this.planDate[0] ? this.planDate[0] : ''}&endPlanDate=${this.planDate[1] ? this.planDate[1] : ''}`);
      },
    },
  };
</script>

<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 70vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 10px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .addressItem {
              font-size: 12px;
              color: rgba(153, 153, 153, 1);
              margin-bottom: 10px;
              margin-left: 70px;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-table .ui-warning-row {
      background: #DDD !important;
    }

    .el-table .ui-warning-row .cell {
      color: red;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
</style>
